import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

import './index.css';
import './theme.scss';

import { SatisfactionContextProvider } from './context/SatisfactionContext';
import { ContentContextProvider } from 'context/ContentContext';

ReactDOM.render(
      <BrowserRouter>
        <SatisfactionContextProvider>
          <ContentContextProvider>
            <App />
          </ContentContextProvider>
        </SatisfactionContextProvider>
      </BrowserRouter>,
    document.getElementById('root')
);